import { getBrand } from './brand'
import { getStage } from './stage'
import { UrlMap } from '../interfaces'
import { getUrlParam } from './url-param'

export type OauthEndpoints = {
  oauthEndpointAuthorize: string;
  oauthEndpointToken: string;
}

const BASE_URLS: UrlMap = {
  'gmx.net': {
    dev: 'https://oauth2-qa.gmx.net',
    qa: 'https://oauth2-qa.gmx.net',
    pre: 'https://oauth2.gmx.net',
    live: 'https://oauth2.gmx.net'
  },
  'gmx.at': {
    dev: 'https://oauth2-qa.gmx.net',
    qa: 'https://oauth2-qa.gmx.net',
    pre: 'https://oauth2.gmx.net',
    live: 'https://oauth2.gmx.net'
  },
  'web.de': {
    dev: 'https://oauth2-qa.web.de',
    qa: 'https://oauth2-qa.web.de',
    pre: 'https://oauth2.web.de',
    live: 'https://oauth2.web.de'
  }
}

const BASE_URLS_PASSPORT: UrlMap = {
  'gmx.net': {
    dev: 'https://oauthbridge-qa.navigator.gmx.net/navigator/oauth2',
    qa: 'https://oauthbridge-qa.navigator.gmx.net/navigator/oauth2',
    pre: 'https://oauthbridge.navigator-pre.gmx.net/navigator/oauth2',
    live: 'https://oauthbridge.navigator.gmx.net/navigator/oauth2'
  },
  'gmx.at': {
    dev: 'https://oauthbridge-qa.navigator.gmx.net/navigator/oauth2',
    qa: 'https://oauthbridge-qa.navigator.gmx.net/navigator/oauth2',
    pre: 'https://oauthbridge.navigator-pre.gmx.net/navigator/oauth2',
    live: 'https://oauthbridge.navigator.gmx.net/navigator/oauth2'
  },
  'web.de': {
    dev: 'https://oauthbridge-qa.navigator.web.de/navigator/oauth2',
    qa: 'https://oauthbridge-qa.navigator.web.de/navigator/oauth2',
    pre: 'https://oauthbridge.navigator-pre.web.de/navigator/oauth2',
    live: 'https://oauthbridge.navigator.web.de/navigator/oauth2'
  }
}

export function getOauthEndpoints(): OauthEndpoints {
  const section = getUrlParam('section')
  const baseUrlsMap = section.indexOf('navigator') !== -1 ? BASE_URLS_PASSPORT : BASE_URLS
  const baseUrl = baseUrlsMap[getBrand()][getStage()]

  return {
    oauthEndpointAuthorize: `${baseUrl}/authorize`,
    oauthEndpointToken: `${baseUrl}/token`
  }
}
